export const GET_SECTIONS = 'providers/AccessManagementSection/GET_SECTIONS';
export const CREATE_SECTION = 'providers/AccessManagementSection/CREATE_SECTION';
export const EDIT_SECTION = 'providers/AccessManagementSection/EDIT_SECTION';
export const DELETE_SECTION = 'providers/AccessManagementSection/DELETE_SECTION';
